/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationRelationDto } from './OrganizationRelationDto';
import {
    OrganizationRelationDtoFromJSON,
    OrganizationRelationDtoFromJSONTyped,
    OrganizationRelationDtoToJSON,
    OrganizationRelationDtoToJSONTyped,
} from './OrganizationRelationDto';

/**
 * 
 * @export
 * @interface FindOrganizationWithRelationsDto
 */
export interface FindOrganizationWithRelationsDto {
    /**
     * 
     * @type {OrganizationRelationDto}
     * @memberof FindOrganizationWithRelationsDto
     */
    organization: OrganizationRelationDto;
    /**
     * 
     * @type {OrganizationRelationDto}
     * @memberof FindOrganizationWithRelationsDto
     */
    parent: OrganizationRelationDto | null;
    /**
     * 
     * @type {Array<OrganizationRelationDto>}
     * @memberof FindOrganizationWithRelationsDto
     */
    children: Array<OrganizationRelationDto>;
    /**
     * 
     * @type {boolean}
     * @memberof FindOrganizationWithRelationsDto
     */
    isRoot: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FindOrganizationWithRelationsDto
     */
    isLeaf: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FindOrganizationWithRelationsDto
     */
    isInternal: boolean;
}

/**
 * Check if a given object implements the FindOrganizationWithRelationsDto interface.
 */
export function instanceOfFindOrganizationWithRelationsDto(value: object): value is FindOrganizationWithRelationsDto {
    if (!('organization' in value) || value['organization'] === undefined) return false;
    if (!('parent' in value) || value['parent'] === undefined) return false;
    if (!('children' in value) || value['children'] === undefined) return false;
    if (!('isRoot' in value) || value['isRoot'] === undefined) return false;
    if (!('isLeaf' in value) || value['isLeaf'] === undefined) return false;
    if (!('isInternal' in value) || value['isInternal'] === undefined) return false;
    return true;
}

export function FindOrganizationWithRelationsDtoFromJSON(json: any): FindOrganizationWithRelationsDto {
    return FindOrganizationWithRelationsDtoFromJSONTyped(json, false);
}

export function FindOrganizationWithRelationsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOrganizationWithRelationsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organization': OrganizationRelationDtoFromJSON(json['organization']),
        'parent': OrganizationRelationDtoFromJSON(json['parent']),
        'children': ((json['children'] as Array<any>).map(OrganizationRelationDtoFromJSON)),
        'isRoot': json['isRoot'],
        'isLeaf': json['isLeaf'],
        'isInternal': json['isInternal'],
    };
}

export function FindOrganizationWithRelationsDtoToJSON(json: any): FindOrganizationWithRelationsDto {
    return FindOrganizationWithRelationsDtoToJSONTyped(json, false);
}

export function FindOrganizationWithRelationsDtoToJSONTyped(value?: FindOrganizationWithRelationsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization': OrganizationRelationDtoToJSON(value['organization']),
        'parent': OrganizationRelationDtoToJSON(value['parent']),
        'children': ((value['children'] as Array<any>).map(OrganizationRelationDtoToJSON)),
        'isRoot': value['isRoot'],
        'isLeaf': value['isLeaf'],
        'isInternal': value['isInternal'],
    };
}

